module.exports = __webpack_public_path__ + "static/media/BC_JobOffer.f05728b1.pdf";